export default __webpack_public_path__ + "static/media/lock_icon_email_sent.776606a4.svg";